import React from 'react';

type Props = {
  width: number;
  height: number;
  color: string;
  vertical: boolean;
};

const Ellipsis = ({ width, height, color, vertical }: Props) => {
  if (vertical) {
    return (
      <svg fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 192 512">
        <path d="M96 184c39.8 0 72 32.2 72 72s-32.2 72-72 72-72-32.2-72-72 32.2-72 72-72zM24 80c0 39.8 32.2 72 72 72s72-32.2 72-72S135.8 8 96 8 24 40.2 24 80zm0 352c0 39.8 32.2 72 72 72s72-32.2 72-72-32.2-72-72-72-72 32.2-72 72z" />
      </svg>
    );
  }
  return (
    <svg fill={color} xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 512 512">
      <path d="M328 256c0 39.8-32.2 72-72 72s-72-32.2-72-72 32.2-72 72-72 72 32.2 72 72zm104-72c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72zm-352 0c-39.8 0-72 32.2-72 72s32.2 72 72 72 72-32.2 72-72-32.2-72-72-72z" />
    </svg>
  );
};

Ellipsis.defaultProps = {
  color: '#6f7782',
  vertical: false,
};

export default Ellipsis;
